module.exports = __webpack_public_path__ + "img/table-placeholder-employee.eadc980e.webp";